require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-alphington-median-house-prices-up-65-2.json") })
        }
      }, "path---news-alphington-median-house-prices-up-65-2");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-alphington-median-house-prices-up-65-2!./.cache/json/news-alphington-median-house-prices-up-65-2.json
// module id = 784
// module chunks = 231608221292675